import React from "react";
import { motion } from "framer-motion";
import pizzaioliImg from "../../assets/team/pizzaioli.png";

export default function PizzaioliSection() {
    return (
        <section id="filosofia" className="bg-background px-6 py-20 text-center max-w-full mx-auto mb-10">
            <motion.h2
                className="text-3xl md:text-4xl font-title text-primary mb-6 tracking-tight"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                La nostra filosofia
            </motion.h2>

            <motion.p
                className="text-muted text-base md:text-lg leading-relaxed mb-8 max-w-3xl mx-auto"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2, duration: 0.6 }}
            >
                Noi de Il Balconcino Food&Beer crediamo che mangiare non sia solo un'azione,
                ma un vero momento per appagare il corpo e la mente. Nei nostri prodotti ci mettiamo tutta la passione che ci contraddistingue,
                utilizzando materie prime di qualità e lavorazioni scrupolose.
            </motion.p>

            <motion.p
                className="text-muted text-base md:text-lg leading-relaxed mb-8 max-w-3xl mx-auto"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3, duration: 0.6 }}
            >
                <strong>Gianmarco</strong> e <strong>Raffaele</strong> sono il cuore pulsante del nostro laboratorio: passione, esperienza e creatività dietro ogni pizza. Un duo affiatato che porta in tavola autenticità e gusto.
            </motion.p>

            <motion.img
                src={pizzaioliImg}
                alt="Gianmarco e Raffaele - I pizzaioli"
                className="w-full max-w-2xl border-2 border-primary mx-auto rounded-2xl object-cover"
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                draggable={false}
            />
        </section>
    );
}
